import React from "react";

export const Marker = React.memo(
  ({ lat, lng }: { lat: number; lng: number }) => {
    return (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translate(-50%, -100%)",
        }}
      >
        <img src={"/images/pin.png"} style={{ width: 40 }} alt="" />
      </div>
    );
  }
);
